import { Action, createReducer, on } from '@ngrx/store';
import * as mobileMenu from '../actions/mobile-menu';

export interface State {
  open: boolean;
}

const initialState: State = {
  open: false
};

export const mobileMenuReducer = createReducer(
  initialState,
  on(mobileMenu.ToggleMobileMenuAction, (state, action) => {
    const open = action.payload !== undefined ? action.payload : !state.open;
    return Object.assign({}, state, { open });
  })
);

export function reducer(state: State | undefined, action: Action): State {
  return mobileMenuReducer(state, action);
}

export const isOpen = (state: State) => state.open;
